// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import styles from '../../pages/toolip.io/dashboard.module.less';

interface i_loader_props {
    is_loading: boolean;
    children: JSX.Element;
}

export const Skeleton_loader = (props: i_loader_props)=>{
    if (!props.is_loading)
        return props.children;
    return <div className={styles.skeleton_loader}>{props.children}</div>;
};

